import React from 'react';
import { clsx } from 'clsx';
import { getCategoryVisual, getIdentifierTypeVisual } from './intelVisualConfig';

type Props = {
    category?: string | null;
    /** When set, maps Harvest id_type instead of entity category. */
    idType?: string | null;
    size?: 'sm' | 'md';
    className?: string;
};

export const CategoryIconTile: React.FC<Props> = ({
    category,
    idType,
    size = 'md',
    className,
}) => {
    const visual = idType != null ? getIdentifierTypeVisual(idType) : getCategoryVisual(category);
    const Icon = visual.icon;
    const dim = size === 'sm' ? 'h-6 w-6' : 'h-7 w-7';
    const iconDim = size === 'sm' ? 'h-3 w-3' : 'h-3.5 w-3.5';

    return (
        <span
            className={clsx(
                'inline-flex shrink-0 items-center justify-center rounded-md border',
                dim,
                visual.tileClass,
                className,
            )}
            aria-hidden
        >
            <Icon className={clsx(iconDim, visual.iconClass)} strokeWidth={2.25} aria-hidden />
        </span>
    );
};
